import { render, staticRenderFns } from "./news_xq.vue?vue&type=template&id=0e770d8c&"
import script from "./news_xq.vue?vue&type=script&lang=js&"
export * from "./news_xq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports